import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

class BaseNotificationTime extends Component {
    static propTypes = {
        timestamp: PropTypes.number.isRequired,
    };

    shouldComponentUpdate() {
        // We prevent the component from re-rendering here so that the
        // relative time displayed on notifications does not change when
        // it gets marked as seen and the highlight fades out.
        return false;
    }

    render() {
        const {
            intl,
            timestamp,
        } = this.props;


        return (
            <p>{intl.formatRelative(new Date(timestamp * 1000))}</p>
        );
    }
}

export const NotificationTime = injectIntl(BaseNotificationTime);
